import { createFileRoute, Outlet, notFound } from "@tanstack/react-router";

export const Route = createFileRoute("/_dev")({
  beforeLoad: () => {
    if (import.meta.env.PROD) throw notFound();
  },
  component: () => <Outlet />,
});
